<!--
/*
 * @Author: your name
 * @Date: 2021-07-05 20:00:34
 * @LastEditTime: 2022-10-20 10:02:30
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @Description: In User Settings Edit
 * @FilePath: \maine:\git\xadc\src\views\ProjectProgress\ProjectProgressSatisfyRate.vue
 * @Description: 满意度评价 - 详情
 */
 -->
<template>
  <div id="satisfaction-rate" class="satisfaction-rate">
    <div class="content-box">
      <span class="page-title">请对测绘作业单位服务做出评价</span>
      <div class="form-box">
        <div class="rate-panel">
          <div class="rate-title">业务编号</div>
          <div class="rate-bar">{{ YWBH }}</div>
        </div>
        <div class="rate-panel" v-for="(item, index) of list" :key="index">
          <div class="rate-title">{{ item.label }}</div>
          <div class="rate-bar">
            <van-rate
              v-model="item.showValue"
              :size="23"
              color="#ffd21e"
              void-icon="star"
              void-color="#eee"
              gutter="20px"
              :count="item.count"
              :readonly="!isEnabled"
            />
          </div>
        </div>
        <van-cell title="评价内容" />
        <div class="">
          <van-field
            v-model="message"
            rows="10"
            autosize
            type="textarea"
            maxlength="255"
            placeholder="(限255字)"
            class="border-message"
            :readonly="!isEnabled"
          />
        </div>

        <!-- <van-button
            class="btn-submit"
            :color="{isSubmit ? '#1D84FF' :'#CFCFCF' }"
            block
            @click.stop="btnSubmit"
            >提交</van-button
          > -->

        <div class="btn-group">
          <van-button
            class="btn-submit"
            color="#1D84FF"
            block
            @click.stop="btnSubmit"
            v-if="isEnabled"
            >提交</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import listMixins from '@/mixins/comListMixins'
import api from '@/utils/api/projectProgress.api'
import opinionApi from '@/utils/api/opinionPublish'

import moduleMixins from '@/mixins/moduleMixins'
export default {
  name: 'SatisfactionRate',
  mixins: [listMixins, moduleMixins],
  components: {},
  props: {},
  data() {
    return {
      message: '', // 评价内容
      statusType: '', // 是否可编辑类型值
      isEnabled: false, // 是否禁用 true则允许编辑，false则禁用
      isSubmit:false, // 是否允许提交
      zlcrId: '', // id
      list: [],// 表单后台配置的满意度评价维度数组
      rid:"",// rid
      YWBH: '', // 业务编号
      rate: {},
      title: '满意度评价',
      CLSX:"",// 测量事项
      CLSXvalue:"",// 测量事项value
      HJINDEX: 0,// 汇交次数
    }
  },
  watch: {},
  computed: {
    navTitle() {
      return this.title
    }
  },
  filters: {},
  methods: {
    loadData() {
      this.getClsxValue()
      this.getRateData()
    },
    getRateData() {// 获取满意度评价维度
      let params = {}
      // 目前没有参数
      api
        .getSatisfactionItem(params)
        .then(res => {
          // CHCGZL// 满意度评价--测绘成果质量
          // CKFWZL// 满意度评价--服务质量
          // RYSZ// 满意度评价--人员素质
          // FWPY// 满意度评价--服务评语
          if(this.isEnabled){// 允许评价
            res.data.forEach(item => {
              item.count = item.value.length ? item.value.length : 5
              item.showValue = this.rate[item.key]
              // console.log('item', item)
            })
          }else{// 查看评价（只读）
            // this.CHCGZL = this.$route.params.CHCGZL// 满意度评价--测绘成果质量
            // this.CKFWZL = this.$route.params.CKFWZL// 满意度评价--服务质量
            // this.RYSZ = this.$route.params.RYSZ// 满意度评价--人员素质
            res.data.forEach(item => {
              if(item.key == 'CHCGZL'){
                item.count = item.value.length ? item.value.length : 5
                item.showValue = this.CHCGZL
              }
              if(item.key == 'CKFWZL'){
                item.count = item.value.length ? item.value.length : 5
                item.showValue = this.CKFWZL
              }
              if(item.key == 'RYSZ'){
                item.count = item.value.length ? item.value.length : 5
                item.showValue = this.RYSZ
              }
              if(item.key == 'FWPY'){
                item.count = item.value.length ? item.value.length : 5
                item.showValue = this.FWPY ? this.FWPY : ''
              }
            })
          }
          this.list = res.data
          //   this.getData() // 先加载配置，然后加载数据
        })
        .catch(err => {
          //登录超时
          if (err.response.data.code == 401) {
            //弹出登录窗
            this.$dialog
              .confirm({
                title: '温馨提示',
                message: err.response.data.msg,
                confirmButtonText: '去登录',
                confirmButtonColor: '#1D84FF'
              })
              .then(() => {
                this.$router.push({
                  name: 'Login'
                })
              })
              .catch(() => {
                // on cancel
                this.$router.go(-1)
              })
          } else {
            this.$toast(err.response.data.msg)
          }
        })
    },
    getData() {
      let params = {}
      // params.ywbh = this.YWBH
    },
    getClsxValue() {
      opinionApi.getClsxValue({
        key: this.CLSX
      }).then(res => {
        // console.log(res)
        this.CLSXvalue = res.data
      })
    },
    btnSubmit() {
      // 提交
      let params = {}
      params.YWBH = this.YWBH // 业务编号
      params.FWPY = this.message // 服务评语
      params.HJINDEX = this.HJINDEX // 汇交次数
      params.CLSX = this.CLSX // 测量事项

      //遍历评价维度list
      this.list.forEach(item => {
        params[item.key] = item.showValue
      })
      console.log('params:', params)
      api[this.CLSX ? 'rateSubmit' : 'allRateSubmit'](params)
        .then(res => {
          this.isSubmit = true

          if(res.code == 0){
            this.$bus.$emit('satisfyListOnload')
            this.$toast.success('提交成功')
            this.$router.go(-1)
          }
          
        })
        .catch(err => {})
    }
  },
  created() {},
  mounted() {
    //  this.getData()
    this.YWBH = this.$route.params.YWBH
    this.rid = this.$route.params.rid
    this.isEnabled = this.$route.params.isEnabled// 是否可编辑（是否已提交评价） true为可编辑（点击评价） false为 已完成(已评价)
    this.title = (this.$route.params.title == '评价' || this.$route.params.title ==  '点击评价') ? '满意度评价' : '查看评价'

    this.CLSX = this.$route.params.CLSX// 测量事项
    this.HJINDEX = this.$route.params.HJINDEX// 汇交次数
    if(!this.isEnabled){// 已完成 评价，加载已评价数据
      this.CHCGZL = Number(this.$route.params.CHCGZL) // 满意度评价--测绘成果质量
      this.CKFWZL = Number(this.$route.params.CKFWZL)// 满意度评价--服务质量
      this.RYSZ = Number(this.$route.params.RYSZ)// 满意度评价--人员素质
      this.message = this.$route.params.FWPY // 已评价 服务评语
    }
    this.loadData()

    // rid: item.rid,
    // YWBH: item.YWBH,// 业务编号
    // CHCGZL:item.CHCGZL,// 满意度评价--测绘成果质量
    // CKFWZL:item.CKFWZL,// 满意度评价--服务质量
    // RYSZ:item.RYSZ,// 满意度评价--人员素质
    // FWPY:item.FWPY,// 满意度评价--服务评语
    // HJINDEX: item.HJINDEX,// 汇交次数 
    // isEnabled: this.isEnabled,// 是否可编辑（是否已提交评价）
    // MYDPJ: item.MYDPJ,// 满意度评价
  },
  activated() {
    // this.loadData()
  }
}
</script>
<style lang="scss" scoped>
.satisfaction-rate {
  background: #ffffff;
  height: 100vh;
  overflow: auto;
  .page-title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 17px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    height: 70px;
  }
  .content-box {
    // height: 15vw;
    /* line-height: 15vw; */
    margin: 0 16px;
    .rate-panel {
      display: flex;
      align-items: center;
      height: 48px;
      .red-star {
        color: #fa6366;
      }
      .rate-title {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        padding: 0 15px;
        position: relative;
        display: flex;
        align-items: center;
        width: 25%;
      }
      .rate-title::before {
        content: '*';
        color: #fa6366;
        font-size: 14px;
        position: absolute;
        font-weight: 500;
        top: 2px;
        left: 0;
      }
    }

    .btn-group {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      padding: 30px 0px 20px 0px;
      .btn-submit {
        width: 92vw;
      }
    }
    .border-message {
      border: 1px solid #dddddd;
    }
  }
}
</style>
